<template>
    <header class="header">
        <v-container>
            <v-layout justify-center align-center>
                <v-flex class="xs12 sm12 md12 lg12 xl9">
                    <div class="header__inner">
                        <div class="header__left">
                            <!--BEGIN LOGO-->
                            <logo></logo>
                            <!--END LOGO-->
                            <!--BEGIN SEARCH-->
                            <search></search>
                            <!--END SEARCH-->
                        </div>
                        <div class="header__right">
                            <!--BEGIN AUTH-->
                            <auth></auth>
                            <!--END AUTH-->
                            <!--BEGIN SWITCHER-->
                            <switcher></switcher>
                            <!--END SWITCHER-->
                            <!--BEGIN LOGOUT-->
                            <logout></logout>
                            <!--END LOGOUT-->
                        </div>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </header>
</template>

<script>
    import switcher from '@/elements/switcher.vue'
    import logo from '@/elements/logo.vue'
    import logout from '@/elements/logout.vue'
    import search from '@/elements/search.vue'
    import auth from './headerAuth.vue'
    export default {
        data() {
            return {
            }
        },
        components: {
            logo,
            switcher,
            logout,
            auth,
            search,
        }
    }
</script>

<style lang="sass" scoped>
    .header
        height: 80px
        background: #FEFEFE
        box-shadow: 0px 5px 10px rgba(1, 37, 78, 0.1)
        position: relative
        z-index: 2
        .container
            padding: 16px 24px
        &__inner
            display: flex
            justify-content: space-between
            align-items: center
        &__left,
        &__right
            display: flex
            align-items: center
            justify-content: center
        &__right
            div + div
                margin-left: 24px


</style>